import { FetchService, UserApi } from '@pib/api';
export * from './cache';
export const userApi = new UserApi(new FetchService());
